import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/boards/style/index.tsx